<template >
<span :key="render">
  <v-text-field
    append-icon="mdi-percent"
    :prepend-icon="`mdi-circle-${percentageIcon}`"
    v-model="localValue"
    v-mask="percentageMask"
    v-bind="$attrs"
    @paste.prevent="handleInputPaste"
    @focus="handleFocus"
  >
  </v-text-field>
</span>
</template>
<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'VfPercentageInput',
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    inputValue: {
      type: [Number, String],
      default: 0
    }
  },
  data () {
    return {
      percentageMask: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        thousandsSeparatorSymbol: ' ',
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: ',',
        decimalLimit: 2,
        integerLimit: 3
      }),
      localValue: this.getStringInputValue(this.value),
      lastValue: this.value,
      valueForCalculation: this.value,
      initialValue: this.value,
      calculatedValue: this.getCalculatedValue(this.value),
      render: 0
    }
  },
  computed: {
    percentageIcon () {
      const mapValue = Math.floor((this.value * 100) / 12)
      return mapValue ? `slice-${mapValue}` : 'outline'
    },
    calulatedValueHint () {
      return this.inputValue
        ? this.$t('common.calculated', { value: this.inputValue * this.value })
        : ''
    }
  },
  watch: {
    value (v) {
      if (v === this.lastValue) {
        return
      }
      this.render++
      this.localValue = this.getStringInputValue(v.toFixed(4))
      this.valueForCalculation = v
      this.initialValue = v
      this.calculatedValue = this.getCalculatedValue(v)
      this.$emit('update:outputValue', this.calculatedValue)
    },
    inputValue (v) {
      this.calculatedValue = this.getCalculatedValue(this.valueForCalculation)
      this.$emit('update:outputValue', this.calculatedValue)
    },
    localValue (value) {
      const cleanValue = value
        ? value.replace(/[ ]+/g, '').trim().replace(',', '.')
        : '0'

      const outputValue = parseFloat((parseFloat(cleanValue) / 100))

      if (this.isInMaskErrorBoundary(outputValue)) {
        this.valueForCalculation = this.initialValue
      } else {
        this.valueForCalculation = outputValue
      }
      this.calculatedValue = this.getCalculatedValue(this.valueForCalculation)

      if (outputValue !== this.lastValue) {
        this.lastValue = outputValue
        this.$emit(
          'input',
          outputValue
        )
        this.inputValue && this.$emit('update:outputValue', this.calculatedValue)
      }
    }
  },
  methods: {
    getStringInputValue (value) {
      return (value * 100).toFixed(2).replace('.', ',')
    },
    getCalculatedValue (percent) {
      return Math.round(percent * this.inputValue)
    },
    handleInputPaste (e) {
      const pastedText = e.clipboardData.getData('text')
      // rough text cleanup to ensure mask compatibility
      this.localValue = pastedText.replace('.', ',')
      this.render++
    },
    isInMaskErrorBoundary (value) {
      return Math.abs(this.initialValue - value) < 0.0001
    },
    handleFocus () {
      this.$emit('focus')
    }
  }
}
</script>
